import { render, staticRenderFns } from "./importBot.vue?vue&type=template&id=1f0aa6c9&"
import script from "./importBot.vue?vue&type=script&lang=js&"
export * from "./importBot.vue?vue&type=script&lang=js&"
import style0 from "./importBot.vue?vue&type=style&index=0&id=1f0aa6c9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports